import type { CreateSimulationRequest } from '@wavingroup/aqora-v2-crate/wavin/simulations/v1/simulations_service_pb';
import { simulationsClient } from '~/services/api/simulations-client';

export const listSystemSimulations = async ({
  systemName,
}: {
  systemName: string;
}) =>
  simulationsClient.listSimulationsForSystem({
    systemName,
  });

export const createSystemSimulation = async (
  request: CreateSimulationRequest,
) => simulationsClient.createSimulation(request);

export const reRunSystemSimulation = async ({
  simulationId,
}: {
  simulationId: string;
}) =>
  simulationsClient.reRunSimulation({
    runAttemptName: simulationId,
  });
